/**
 * @module Routes.Unsubscribe
 *
 */
import React, { useState, useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { defineMessages, MessageDescriptor } from 'react-intl';
import { fetchGet, fetchPut } from 'app/utils/request';
import { Loc } from 'app/components/helpers';
import { Public } from 'app/components/Wrappers';
import Styles from './styles.module.scss';

type PropsDef = RouteComponentProps<{
  spaceId: string;
  token: string;
}>;

type State = {
  error: MessageDescriptor | null;
  pending: boolean;
  data: any;
};

const initialState: State = {
  error: null,
  pending: true,
  data: null,
};

/**
 * @class Space
 *
 */
export default function User(props: PropsDef) {
  const { spaceId, token } = props.match.params;
  const url = `spaces/${spaceId}/user_settings?token=${token}`;
  const [ state, setState ] = useState(initialState);

  const saveSettings = (data: any) => {
    setState({ ...state, pending: true });

    fetchPut(url, { user_settings: state.data }, { version: 1, noAuth: true })
      .then(() => setState({ ...state, data, pending: false }))
      .catch(() => setState({ ...state, pending: false, error: locales.saveError }));
  };

  const unsubscribe = () => {
    const data = { ...state.data, emailNotificationsEnabled: false };
    saveSettings(data);
  };

  const subscribe = () => {
    const data = { ...state, emailNotificationsEnabled: true };
    saveSettings(data);
  };

  useEffect(() => {
    const params = { "options[include]": ['space'] };
    fetchGet(url, params, { version: 1, noAuth: true })
      .then((settings) => setState({ ...state, data: settings, pending: false }))
      .catch(() => setState({ ...state, pending: false, error: locales.error }));
  }, [ spaceId ]);

  useEffect(() => {
    if (state.data && state.data.space) {
      // unsubscribe();
    }
  }, [ state.data ]);


  let message = (
    <h3 className="text-center">
      <Loc value={locales.pending} />
    </h3>
  );

  if (!state.pending && state.error) {
    message = (
      <h3 className="text-danger text-center">
        <Loc value={state.error} />
      </h3>
    );
  } else if (!state.pending && !state.error) {
    if (state.data != null) {
      if (state.data.emailNotificationsEnabled) {
        message = (
          <div>
            <h3 className="text-success text-center">
              <Loc value={locales.resubscribe} />
            </h3>

            <p className="text-center">
              <button className="btn btn-primary" onClick={unsubscribe}>
                <Loc value={locales.unsubscribe_button} />
              </button>
            </p>
          </div>
        );
      } else {
        let subMess = (<span></span>);
        const values = { name: state.data.space.ownerName, sport: state.data.space.sport };
        if (state.data.space.type.toLowerCase() === 'athlete') {
          subMess = (
            <span>
              <Loc value={{...locales.for_user_sport, values}} />
            </span>
          );
        } else if (state.data.space.type.toLowerCase() === 'team') {
          subMess = (
            <span>
              <Loc value={{...locales.for_team_sport, values}} />
            </span>
          );
        }

        message = (
          <div>
            <h3 className="text-success text-center">
              <Loc value={locales.unsubscribe} />&nbsp;{subMess}
            </h3>

            <p className="text-center">
              <button className="btn btn-large btn-primary" onClick={subscribe}>
                <Loc value={locales.subscribe_again} />
              </button>
            </p>
          </div>
        );
      }
    }
  }

  return (
    <Public isLoading={false}>
      <div className={Styles.unsubscribeMain}>
        <div className="panel">
          {message}
        </div>
      </div>
    </Public>
  );
}

const locales = defineMessages({
  subscribe_again: { id: 'unsubscribe.space.subscribe_again', defaultMessage: 'Subscribe me again!' },

  resubscribe: { id: 'unsubscribe.space.resubscribe', defaultMessage: 'You are now subscribed to email notifications' },
  unsubscribe_button: { id: 'unsubscribe.space.resubscribe_button', defaultMessage: 'Unsubscribe' },

  unsubscribe: { id: 'unsubscribe.space.unsubscribe', defaultMessage: 'You have unsubscribed from email notifications' },

  for_user_sport: { id: 'unsubscribe.space.for_user_sport', defaultMessage: "for {name} / {sport} Training Space" },
  for_team_sport: { id: 'unsubscribe.space.for_team_sport', defaultMessage: 'for {name} / {sport} Training Team' },

  pending: { id: 'unsubscribe.space.pending', defaultMessage: 'Please, wait...' },
  success: { id: 'unsubscribe.space.success', defaultMessage: 'You have unsubscribed from email notifications for this invitation' },
  error: { id: 'unsubscribe.space.error', defaultMessage: 'Due to server error we were not able to save your changes' },
  saveError: { id: 'unsubscribe.space.error', defaultMessage: 'Due to server error we were not able to save your changes' },
  invalid: { id: 'unsubscribe.space.invalid', defaultMessage: 'The invitation is invalid or no longer exists.' }
});


